module.exports = __webpack_public_path__ + "img/text.672a71c5.jpg";